import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
const API = "https://api.ctexpresskh.com/api";

const DEFAULT_KEYS = [
  // Navigation
  "home","track","warehouse","profile","more","new_parcel",
  // Auth
  "login","register","logout","otp_login","forgot_password","change_password",
  "save_password","current_password","new_password","confirm_new_password",
  "reset_password","phone","password","full_name","confirm_password",
  "send_otp","verify_otp","resend_otp","otp_note","login_with_otp",
  "no_account","have_account",
  // Shipments
  "my_shipments","no_shipments","no_shipments_found","total","in_transit",
  "kh_wh","cn_wh","delivered","pending","delivery","signed",
  "all","oversea","intransit","local","sign","unknown",
  // Tracking
  "enter_tracking","track_shipment","track_parcels","status_timeline",
  "search_tracking","tracking_number","goods_description","weight",
  "shipping_method","shipping_fee","quantity","origin","destination",
  // Warehouse/Logistics
  "china_warehouse","customer_id","copy_all","receiver","region",
  "address","copied","land_route","sea_route","air_route",
  "by_land","by_sea","by_air",
  // Profile
  "my_address","city","save_address","address_saved",
  // Est Price
  "est_price","calculate","reset","shipping_cost","width","length","height","size_cm",
  // Exchange
  "exchange","money_transfer","rate_on",
  // Support
  "support","contact_us",
  // Add Parcel
  "add_parcel","submit","parcel_submitted",
  // General
  "hello","login_to_view","language","cancel","save","edit","delete",
  "close","back","next","loading","error","success","connection_error",
  "developed_by",
  // Home Menu
  "logistics","my_address_menu","est_price_menu","exchange_menu",
  "support_menu","news_feed","refresh",
  // Legacy
  "track_shipment","status_timeline","resend_otp","no_account","have_account"
];

export default function MobileTranslations() {
  const [langs] = useState(["en","kh","cn"]);
  const [activeLang, setActiveLang] = useState("en");
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => { loadAll(); }, []);

  const loadAll = async () => {
    try {
      const res = await fetch(API + "/mobile/translations", { headers: { Authorization: "Bearer " + token } });
      const data = await res.json();
      if (data.success) setTranslations(data.data || {});
    } catch {}
  };

  const save = async () => {
    setLoading(true);
    try {
      const res = await fetch(API + "/mobile/translations", {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ translations })
      });
      const data = await res.json();
      if (data.success) toast.success("Translations saved!");
      else toast.error(data.message);
    } catch { toast.error("Error saving"); }
    setLoading(false);
  };

  const setVal = (lang, key, val) => {
    setTranslations(prev => ({
      ...prev,
      [lang]: { ...(prev[lang] || {}), [key]: val }
    }));
  };

  const langLabels = { en: "🇬🇧 English", kh: "🇰🇭 Khmer", cn: "🇨🇳 Chinese" };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <div>
          <h2 style={{ margin:0, fontSize:22, fontWeight:700 }}>📱 Mobile App Translations</h2>
          <p style={{ margin:"4px 0 0", color:"#6b7280", fontSize:13 }}>Manage translations for the mobile app</p>
        </div>
        <button onClick={save} disabled={loading} style={{ backgroundColor:"#dc2626", color:"#fff", border:"none", borderRadius:8, padding:"10px 24px", fontWeight:700, cursor:"pointer" }}>
          {loading ? "Saving..." : "💾 Save All"}
        </button>
      </div>

      <div style={{ display:"flex", gap:8, marginBottom:24 }}>
        {langs.map(l => (
          <button key={l} onClick={() => setActiveLang(l)}
            style={{ padding:"8px 20px", borderRadius:8, border:"2px solid", borderColor: activeLang===l ? "#dc2626":"#e5e7eb", backgroundColor: activeLang===l ? "#fff0f0":"#fff", color: activeLang===l ? "#dc2626":"#374151", fontWeight:700, cursor:"pointer" }}>
            {langLabels[l]}
          </button>
        ))}
      </div>

      <div style={{ backgroundColor:"#fff", borderRadius:12, border:"1px solid #e5e7eb", overflow:"hidden" }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ backgroundColor:"#f9fafb" }}>
              <th style={{ padding:"12px 16px", textAlign:"left", fontSize:12, fontWeight:700, color:"#6b7280", width:"30%" }}>KEY</th>
              <th style={{ padding:"12px 16px", textAlign:"left", fontSize:12, fontWeight:700, color:"#6b7280" }}>
                {langLabels[activeLang]} VALUE
              </th>
            </tr>
          </thead>
          <tbody>
            {DEFAULT_KEYS.map((key, i) => (
              <tr key={key} style={{ borderTop:"1px solid #f3f4f6", backgroundColor: i%2===0 ? "#fff":"#fafafa" }}>
                <td style={{ padding:"10px 16px", fontSize:13, color:"#6b7280", fontFamily:"monospace" }}>{key}</td>
                <td style={{ padding:"6px 16px" }}>
                  <input
                    value={(translations[activeLang] || {})[key] || ""}
                    onChange={e => setVal(activeLang, key, e.target.value)}
                    placeholder={`Enter ${activeLang} translation...`}
                    style={{ width:"100%", padding:"7px 10px", border:"1px solid #e5e7eb", borderRadius:6, fontSize:13, boxSizing:"border-box" }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
